/**
 * @desc 根据多个sku查询出对应的MSKU
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.omsFlow.MskuRequestRpcDto>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/msku/getByItemSkuList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
